import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { FaEdit, FaCheck, FaTrashAlt } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { toast } from "react-toastify";
// import { clearErrors } from "../../store/actions";
import { getDateTime } from "../../utils/function";
import { toastOptions } from "../../utils/error";
import MotionDiv from "./MotionDiv";
import MessageBox from "./MessageBox";
import moment from "moment-timezone";

/**
 * Renders a card component to display details with optional loading state and edit functionality.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.loading - Specifies whether the component is in a loading state.
 * @param {function} props.setModalShow - Function to toggle the modal show state.
 * @param {Object} props.data - The data object containing the details to display.
 * @param {Object} props.keyProps - An object containing key-value pairs for mapping keys to attribute names.
 * @returns {JSX.Element} The rendered card component.
 *
 * @example
 * // Example usage of the ViewCard component
 * <ViewCard
 *   loading={false}
 *   setModalShow={handleModalToggle}
 *   data={{
 *     fullname: 'John Doe',
 *     createdAt: '2022-05-15T10:30:00Z',
 *     updatedAt: '2022-05-20T14:45:00Z',
 *   }}
 *   keyProps={{
 *     name: 'fullname',
 *     created: 'createdAt',
 *     updated: 'updatedAt',
 *   }}
 * >
 *   <CustomComponent />
 * </ViewCard>
 **/

const boolComp = (val) => {
  return val ? <FaCheck className="green" /> : <ImCross className="red" />;
};

const isDate = (date) => {
  return new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};

const isISODate = (value) => {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
  return isoDateRegex.test(value);
};

const dynamicComp = (val) => {
  const dataType = typeof val;
  // console.log({ type: Date.parse(val), val, dataType });
  switch (dataType) {
    case "number":
      return val;
    case "boolean":
      return boolComp(val);
    default:
      // console.log({ val });
      const res = val
        ? isISODate(val) && !val.includes("%")
          ? moment(val).tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss")
          : val
        : "---";
      // console.log({ res });
      return res;
  }
};

const getNestedValue = (obj, keyString) => {
  const keys = keyString.split("."); // Split the string into an array of keys

  const ans = keys.reduce((acc, key) => {
    return acc && acc[key] !== undefined ? acc[key] : 0;
  }, obj);

  return ans;
};

export default function ViewCard(props) {
  const {
    data,
    keyProps,
    title,
    isImage,
    image_url,
    successMsg,
    reducerProps,
    handleDelete,
    setModalShow,
  } = props;

  const {
    isLoading: loading,
    error,
    dispatch,
    success,
    isFetching,
  } = reducerProps;

  useEffect(() => {
    if (error) {
      toast.error(error, toastOptions);
      // clearErrors(dispatch);
    }

    if (success) {
      toast.success(successMsg, toastOptions);
    }
  }, [error, success]);

  const fields = Object.entries(keyProps);
  return (
    <MotionDiv initial={{ x: "100%" }}>
      {error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <Card>
          <Card.Header>
            {title ? (
              <Card.Title>{title}</Card.Title>
            ) : (
              <Skeleton count={1} height={35} width={200} baseColor="#afafaf" />
            )}
            <div className="card-tools">
              {props.showEdit && (
                <FaEdit
                  style={{ color: "blue" }}
                  onClick={() => {
                    console.log("hasiudgs");
                    setModalShow(true);
                  }}
                />
              )}
              {title === "Terms of Use" || title === "Privacy Policy" ? (
                <FaTrashAlt onClick={handleDelete} className="mx-3" />
              ) : (
                ""
              )}
            </div>
          </Card.Header>
          <Card.Body>
            {isImage ? (
              <Row>
                <Col md={4}>
                  {isFetching ? (
                    <Skeleton height={200} />
                  ) : (
                    <img
                      className="img-fluid"
                      src={image_url}
                      alt=""
                      width={"200px"}
                      height={"200px"}
                    />
                  )}
                </Col>
                <Col>
                  <Row>
                    {fields &&
                      fields.map(([k, attr]) => {
                        // console.log({ k, attr })
                        // console.log(k, dynamicComp(getNestedValue(data, attr)));
                        return (
                          <Col key={k} md={4}>
                            <p className="mb-0">
                              <strong>{k}</strong>
                            </p>
                            <p>
                              {isFetching ? (
                                <Skeleton />
                              ) : k === "Tops" ||
                                k === "Mids" ||
                                k === "Lowers" ||
                                k === "THC Total" ||
                                k === "CBD" ? (
                                `${dynamicComp(getNestedValue(data, attr))}%`
                              ) : (
                                dynamicComp(getNestedValue(data, attr))
                              )}
                            </p>
                          </Col>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
            ) : title === "Terms of Use" || title === "Privacy Policy" ? (
              <Row>
                {fields &&
                  fields.map(([k, attr]) => {
                    // console.log({ k, attr })
                    return (
                      <Col key={k} md={12}>
                        <i>
                          {isFetching ? (
                            <Skeleton />
                          ) : (
                            dynamicComp(getNestedValue(data, attr))
                          )}
                        </i>
                      </Col>
                    );
                  })}
              </Row>
            ) : (
              <Row>
                {fields &&
                  fields.map(([k, attr]) => {
                    // console.log({ k, attr })
                    return (
                      <Col key={k} md={4}>
                        <p className="mb-0">
                          <strong>{k}</strong>
                        </p>
                        <p>
                          {isFetching ? (
                            <Skeleton />
                          ) : (
                            dynamicComp(getNestedValue(data, attr))
                          )}
                        </p>
                      </Col>
                    );
                  })}
              </Row>
            )}
            {props.children}
          </Card.Body>
        </Card>
      )}
    </MotionDiv>
  );
}
